import { ReactNode } from 'react'
import type { TableNode } from '@table-library/react-table-library/types/table'
import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import type { Option } from 'shared/components/ContextMenu/types'
import type { CardTableColumn } from 'styles/table'
import type { AreaItem } from 'features/areas/types/areas.types'

type UseColumnsProps = {
	menuOptions: Option[]
}

const textClassName = 'block truncate text-[13px] text-muted-foreground'

const cell = (render: (booth: AreaItem) => ReactNode) => (node: TableNode) =>
	render(node as unknown as AreaItem)

export const useColumns = ({ menuOptions }: UseColumnsProps): CardTableColumn[] => {
	const { t } = useTranslation()

	return [
		{
			label: t('Area'),
			width: 'minmax(120px, 2fr)',
			padding: '12px 16px',
			renderCell: cell((item) => (
				<span className="block truncate text-[13px] font-semibold text-foreground">
					{item.number}
				</span>
			)),
			select: true,
			pinLeft: true
		},
		{
			label: t('Type'),
			width: 'minmax(160px, 2fr)',
			padding: '12px 16px',
			renderCell: cell((item) => <span className={textClassName}>{item.booth_type_name}</span>)
		},
		{
			label: t('Status'),
			width: 'minmax(120px, 2.7fr)',
			padding: '12px 16px',
			renderCell: cell((item) => (
				<span className={textClassName}>{item.is_active ? t('Active') : t('Inactive')}</span>
			))
		},
		{
			label: '',
			width: '48px',
			padding: '12px 8px',
			renderCell: cell((item) => (
				<ContextMenu
					dataId={item.id}
					item={item}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: item.number })}
				/>
			))
		}
	]
}
